module.exports = __webpack_public_path__ + "img/mysc@2x.27ae8c3c.png";